export type CalculusArea =
  | 'PURCHASE'
  | 'FREIGHT'
  | 'MARKUP'
  | 'PRICE_SUGGESTION'
  | 'CUSTOMER_MARKUP'
  | 'SALES_PRICES'
  | 'ROUNDING'
  | 'PRICE_SOURCE'
  | 'ALL_CONDITIONS';

export enum CalculusTab {
  ITEMS = 'items',
  PURCHASE = 'purchase',
  FREIGHT = 'freight',
  MARKUP = 'markup',
  PRICE_SUGGESTION = 'priceSuggesiton',
  CUSTOMER_MARKUP = 'customerMarkup',
  SALES_PRICES = 'salesPrices',
  ROUNDING = 'rounding',
  PRICE_SOURCE = 'priceSource',
  ALL_CONDITIONS = 'allConditions',
}
